import {BaseFormModel} from './base-form-model';
import {MenuItemPrice} from './menu-item-price';

export class MenuItemInventoryPriceAdjustment extends BaseFormModel<MenuItemInventoryPriceAdjustment> {
    id: number;
    menuItemPrice: MenuItemPrice;
    count: number;
}
